'use strict';

angular.module('ClinicApp').factory('UserService', function($q, $http, ClinicConfig, UserResource, NewPasswordResource, LoginResource, LogoutResource, RequestResetPasswordResource, SubmitResetPasswordResource, SignupResource, VerifyEmailResource, SendEmailAddressVerificationResource, GrowlService, UserPaymentCardResource, CurrentUser) {
  return {
    login: function(email, password, extraParams) {
      if (!email || !password) {
        return $q.reject('UserService.login: email and password are required.');
      }
      return LoginResource.save(_.merge({
        email: email,
        password: password,
      }, extraParams)).$promise;
    },

    logout: function() {
      return LogoutResource.save().$promise;
    },

    updatePaymentCard: function(userId, card) {
      return UserPaymentCardResource.save({
        id: userId,
      }, card).$promise;
    },

    deletePaymentSource: function(userId, sourceId) {
      return UserPaymentCardResource.remove({
        id: userId,
        cardId: sourceId,
      }).$promise;
    },

    /**
     * Retrieves a token for the Plaid Link and creates a new instance.
     *
     * https://plaid.com/docs/auth/partnerships/stripe/#instructions
     */
    getPlaidLinkInstance: function(userId, onSuccess, onExit) {
      return $http.get(`${ClinicConfig.HOSTNAME}/user/${userId}/payment/plaidLinkToken`).then((response) => {
        const token = response.data.linkToken;
        return Plaid.create({
          token,
          onSuccess: (publicToken, metadata) => {
            if (typeof onSuccess === 'function') {
              onSuccess(publicToken, metadata);
            }
          },
          onExit: () => {
            if (typeof onExit === 'function') {
              onExit();
            }
          },
        });
      });
    },

    /**
     * Create a bank account payment source from Plaid.
     */
    createBankAccountFromPlaid: function(userId, plaidLinkPublicToken, plaidAccountId) {
      return $http.post(`${ClinicConfig.HOSTNAME}/user/${userId}/payment/plaidBankAccount`, {
        publicToken: plaidLinkPublicToken,
        accountId: plaidAccountId,
      }).then((response) => response.data);
    },

    signup: function(email, password, firstName, lastName) {
      return SignupResource.save({
        email: email,
        password: password,
        firstName: firstName || null,
        lastName: lastName || null,
        signupType: 'clinic',
      }).$promise;
    },

    onboard: function(email, password, firstName, lastName, jobTitle, signedDocumentTypes) {
      return $http.put(ClinicConfig.HOSTNAME + '/user/onboardClinic', {
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        jobTitle: jobTitle,
        signedDocumentTypes: signedDocumentTypes,
      }).then(function(response) {
        return response.data;
      });
    },

    requestResetPassword: function(email) {
      return RequestResetPasswordResource.save({
        email: email,
      }).$promise;
    },

    submitResetPassword: function(email, token, password) {
      return SubmitResetPasswordResource.save({
        email: email,
        token: token,
        newPassword: password,
      }).$promise;
    },

    updateCurrentUser: function(data) {
      return UserResource.update(null, data).$promise;
    },

    updateCurrentUserPassword: function(oldPassword, newPassword) {
      return NewPasswordResource.update(null, {
        oldPassword: oldPassword,
        newPassword: newPassword,
      }).$promise;
    },

    verifyEmail: function(email, token, requestingUser) {
      return VerifyEmailResource.save({
        email: email,
        token: token,
        requestingUser: requestingUser,
      }).$promise;
    },

    sendEmailVerification: function(email) {
      return SendEmailAddressVerificationResource.save({
        email: email,
      }).$promise.then(function() {
        GrowlService.success('Your email address verification email has been successfully sent. Please check your inbox.');
      });
    },

    getClinicInvoiceReportPeriodMap: (clinicId) => {
      return $http.get(`${ClinicConfig.HOSTNAME}/user/payment/clinic/${clinicId}/invoiceReport`, {
        cache: true,
      }).then((response) => response.data);
    },

    getClinicInvoiceReport: (clinicId, year, month) => {
      return $http.get(`${ClinicConfig.HOSTNAME}/user/payment/clinic/${clinicId}/invoiceReport/${year}/${month}`).then((response) => response.data);
    },

    setClinicOnboardingFlag: function(finished) {
      return $http.patch(ClinicConfig.HOSTNAME + '/user/setClinicOnboardingFlag', {
        finished,
      }).then(function() {
        return CurrentUser.update();
      });
    },

    trackModalShown: ({
      modalName,
    }) => {
      return $http.put(
        `${ClinicConfig.HOSTNAME}/user/trackModalShown`,
        {
          modalName,
        },
      );
    },

    trackModalCta: ({
      modalName,
    }) => {
      return $http.put(
        `${ClinicConfig.HOSTNAME}/user/trackModalCta`,
        {
          modalName,
        },
      );
    },
  };
});
